const hashes = [
  { name: "sha256", display: "SHA-256" },
  { name: "sha512", display: "SHA-512" },
  { name: "md5", display: "MD5" },
  { name: "sha1", display: "SHA-1" },
  { name: "sha224", display: "SHA-224" },
  { name: "sha384", display: "SHA-384" },
  { name: "sha3", display: "SHA-3" },
  { name: "ripemd160", display: "RIPEMD-160" },
];

const counts = [1, 2, 3, 4, 5, 10, 20, 25, 50, 100, 200, 500, 1000];

const RandomHashesGeneratorOptions = (
  {
    options: { type = "sha256", count = 20 } = {},
    onChange,
    strings,
    toolStrings: { hashTypesLabel },
  } = {
    options: {},
  }
) => (
  <div className={"p-0 m-1 pb-2 d-flex flex-row"}>
    <div>
      <label forhtml="typeLabel ">{hashTypesLabel}</label>
      <select
        className="form-select"
        aria-label="type"
        onChange={({ target: { value } }) => onChange({ type: value, count })}
        value={type}
      >
        {hashes.map(({ name, display }) => (
          <option key={name} value={name}>
            {display}
          </option>
        ))}
      </select>
    </div>
    <div className="ms-3">
      <label forhtml="countLabel">{strings.Count}</label>
      <select
        className="form-select"
        onChange={({ target: { value } }) =>
          onChange({ type, count: parseInt(value) })
        }
        value={count}
        aria-label="Count"
      >
        {counts.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>
    </div>
  </div>
);

export default RandomHashesGeneratorOptions;
